import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowProductDetail, setEditingVariantItem } from "../../redux/features/restaurants/restaurantSlice";
import { getItemDetailsAsync } from "../../redux/features/restaurants/restaurantThunks";
import { selectServiceType } from "../../redux/features/customer/customerSelectors";
import { selectCateringItems } from "../../redux/features/restaurants/restaurantSelectors";

const VariantDropdown = ({ item, removeSubItem, addSubItem, branchDetails, isCatering = false }) => {
  const dispatch = useDispatch();
  const [loadingVariantId, setLoadingVariantId] = useState(null);
  const serviceType = useSelector(selectServiceType);
  const cateringItems = useSelector(selectCateringItems);

  // Determine if this is a catering context
  const isCateringContext = isCatering ?
    serviceType === "corporate catering" ||
    serviceType === "individual catering" : false;

  const getSelectedOptions = (itemVariant) => {
    // Get all selected options with quantity > 0
    const selectedOptions = itemVariant.selectedVariant.flatMap((variant) =>
      variant.options
        .filter((opt) => opt.option_quantity > 0)
        .map((opt) => opt.option_name)
    );

    // If no options are selected, return the item name
    return selectedOptions.length > 0
      ? selectedOptions.join(", ")
      : item[0]?.name || "";
  };
  const handleVariantItemClick = (variantItem, itemVariant) => {
    setLoadingVariantId(itemVariant.variantId);

    // If the variant item or ID is missing, just set the editing state without fetching
    if (!variantItem || !variantItem.id) {
      console.error("Cannot set editing state: Item or item ID is missing", variantItem);
      dispatch(setEditingVariantItem({
        productInfo: variantItem,
        variantInfo: itemVariant
      }));
      setLoadingVariantId(null);
      return;
    }

    if (isCateringContext) {
      // For catering, use the existing cateringItems instead of fetching
      const itemDetails = cateringItems?.find(cateringItem => cateringItem.id === variantItem.id);

      if (itemDetails) {
        // Set the editing state directly with catering item details
        dispatch(setEditingVariantItem({
          productInfo: itemDetails,
          variantInfo: itemVariant
        }));
      } else {
        console.error("Catering item not found in cateringItems:", variantItem.id);
        dispatch(setEditingVariantItem({
          productInfo: variantItem,
          variantInfo: itemVariant
        }));
      }

      // Show the product detail view
      dispatch(setShowProductDetail(true));
      setLoadingVariantId(null);
    } else {
      // For normal menu, fetch product details as before
      // Extract restaurant and branch IDs safely
      let restaurantId = branchDetails?.restaurant_id;
      let branchId = branchDetails?.branch_id;

      // First fetch the product details to ensure all variant information is loaded
      dispatch(
        getItemDetailsAsync(
          restaurantId,
          branchId,
          variantItem.id
        )
      ).then(() => {
        // Now that we have the product details loaded, set the editing state
        dispatch(setEditingVariantItem({
          productInfo: variantItem,
          variantInfo: itemVariant
        }));

        // Show the product detail view
        dispatch(setShowProductDetail(true));
        setLoadingVariantId(null);
      }).catch(error => {
        console.error("Failed to fetch product details:", error);
        setLoadingVariantId(null);
      });
    }
  };

  return (
    <>
      {item.map((variantItem, index) => (
        <div
          key={variantItem.id + "-" + index}
          className="absolute left-2.5 right-2.5 top-[142px] bg-[#FBFBFB] border border-gray-300 rounded-b-xl shadow-md px-2 pt-1 z-50 w-auto"
          style={{ maxWidth: "calc(100% - 20px)" }}
        >
          <div className="flex flex-col gap-1 py-1">
            {variantItem.items?.map((itemVariant) => (
              <div
                key={itemVariant.variantId}
                className="flex items-center justify-between text-[10px] py-1"
              >
                <span
                  className={`text-xs truncate w-[150px] block cursor-pointer ${loadingVariantId === itemVariant.variantId
                      ? "text-gray-400"
                      : "hover:text-amber-100"
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (loadingVariantId !== itemVariant.variantId) {
                      handleVariantItemClick(variantItem, itemVariant);
                    }
                  }}
                >
                  {getSelectedOptions(itemVariant)}
                </span>
                <div className="flex items-center bg-[#E9E9E9] rounded-md h-[19px] px-1">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      removeSubItem(variantItem, itemVariant);
                    }}
                    className="w-6 h-6 rounded flex items-center justify-center text-sm hover:bg-gray-200"
                  >
                    -
                  </button>
                  <span className="h-4 text-xs w-6 text-center">
                    {itemVariant.quantity}
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      addSubItem(variantItem, itemVariant);
                    }}
                    className="w-6 h-6 rounded flex items-center justify-center text-sm hover:bg-gray-200"
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default VariantDropdown;
